import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import usePageMeta from '../../hooks/usePageMeta';


function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary">
      {'Copyright © '}
      <Link color="inherit" href="https://thewarriortribe.xyz">
        The Warrior Tribe
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const STORE_URL = process.env.REACT_APP_CHROME_STORE_URL;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    marginTop: theme.spacing(20),
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
  },
  imageFrame:{
    alignItems: 'center'
  },
  image: {
      width: 200,
      height: 200,
      objectFit: 'cover',
      maxWidth: '100%',
      borderRadius: '50%'
  },
  link: {
    marginTop: '25px'
  },
  cardGrid: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    backgroundSize:'auto',
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
}));

export default function Landing() {
  const classes = useStyles();
  usePageMeta(null, "The Warrior Tribe — a Chrome extension for blocking adult content sites and building better digital habits. Track your streak, earn XP, and take back control of your focus and wellbeing.");

  let directToStore = () => {
    let win = window.open(STORE_URL, '_blank');
    win.focus();
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Container component="main" className={classes.main} maxWidth="sm">
      <div className={classes.imageFrame}>
        <img src="../images/player_icon.png"alt="profile" className={classes.image} />
      </div>
        <Typography variant="h2" component="h1" gutterBottom>
          Mr. NoFap
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          {'A Chrome Extension for Digital Wellbeing and Habit Recovery'}
        </Typography>
        <Button onClick={()=> directToStore()} variant="contained" color="primary" className={classes.link}>
          Download Plugin from the Chrome Store
        </Button>
        <div style={{marginTop: '16px'}}>
          <Link href="/about" color="primary" style={{marginRight: '24px'}}>About Us</Link>
          <Link href="/blog" color="primary">Read Our Blog</Link>
        </div>
      </Container>

      <Container className={classes.cardGrid} maxWidth="md">
          {/* End hero unit */}
          <Grid container spacing={7}>
              <Grid item xs={12} sm={6} md={4}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image="../../images/block.png"
                    title="Block"
                  />
                  <CardContent className={classes.cardContent}>
                    <Typography gutterBottom variant="h5" component="h2">
                    Blocks Adult Content Sites
                    </Typography>
                    <Typography>
                    This extension automatically blocks adult content websites the moment you install it.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image="../../images/increase.png"
                    title="Increase"
                  />
                  <CardContent className={classes.cardContent}>
                    <Typography gutterBottom variant="h5" component="h2">
                      Gain Experience
                    </Typography>
                    <Typography>
                      You gain daily experience when you don't visit any porn sites for the day.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image="../../images/decrease.png"
                    title="Decrease"
                  />
                  <CardContent className={classes.cardContent}>
                    <Typography gutterBottom variant="h5" component="h2">
                      Lose Experience
                    </Typography>
                    <Typography>
                      You lose experience if you visit any porn sites.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
          </Grid>
        </Container>

        {/* What is NoFap */}
        <Container maxWidth="md" style={{marginTop: '48px', marginBottom: '48px', textAlign: 'left'}}>
          <Typography variant="h4" gutterBottom>What is NoFap?</Typography>
          <Typography variant="body1" paragraph>
            NoFap is a movement and lifestyle choice focused on abstaining from pornography and compulsive sexual behaviors. Millions of people worldwide have discovered that reducing or eliminating pornography consumption leads to significant improvements in mental clarity, motivation, and overall wellbeing.
          </Typography>
          <Typography variant="body1" paragraph>
            Research suggests that excessive pornography use can affect the brain's reward system, leading to desensitization, reduced motivation, and difficulty concentrating. By breaking free from compulsive habits, many users report experiencing a gradual restoration of natural drive, focus, and emotional balance.
          </Typography>
          <Typography variant="body1" paragraph>
            The Warrior Tribe is built for people who have made the decision to take control of their habits. Our Chrome extension provides a practical, automated barrier that helps you stay on track, while the XP and streak system keeps you motivated and accountable every single day.
          </Typography>
        </Container>

        {/* How It Works */}
        <Container maxWidth="md" style={{marginBottom: '48px', textAlign: 'left'}}>
          <Typography variant="h4" gutterBottom>How The Warrior Tribe Works</Typography>
          <Typography variant="body1" paragraph>
            Getting started takes less than two minutes. Install the Chrome extension from the Chrome Web Store, sign in with your Google account, and the extension immediately begins blocking thousands of adult websites across the web.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Automatic blocking:</strong> The extension maintains an extensive blocklist, updated regularly, covering the most common adult sites. When you attempt to visit a blocked site, you are immediately redirected — removing the temptation before it can take hold.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>XP and leveling system:</strong> Every clean day earns you experience points. Your avatar levels up as you accumulate XP, giving you a visual representation of your progress. Visit a blocked site and you lose XP — a meaningful consequence that reinforces accountability.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Streak tracking:</strong> Your current streak — the number of consecutive clean days — is displayed prominently on your profile. Watching that number grow is one of the most powerful motivators in staying consistent.
          </Typography>
        </Container>

        {/* Benefits */}
        <Container maxWidth="md" style={{marginBottom: '48px', textAlign: 'left'}}>
          <Typography variant="h4" gutterBottom>Benefits Users Report</Typography>
          <Typography variant="body1" paragraph>
            Thousands of people who have reduced or eliminated pornography use report a wide range of benefits. While individual results vary, the following are among the most commonly reported improvements:
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Improved focus and concentration:</strong> Without the constant pull of compulsive habits, many users find it significantly easier to concentrate on work, study, and creative projects for extended periods.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Increased energy and motivation:</strong> Many users report higher baseline energy levels and a renewed drive to pursue goals that previously felt out of reach.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Better confidence and social ease:</strong> Removing shame around compulsive behavior often leads to greater self-confidence and more natural social interactions.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Improved sleep quality:</strong> Reduced late-night screen time and lower anxiety levels contribute to deeper, more restful sleep for many users.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Greater emotional stability:</strong> Compulsive pornography use is often linked to mood swings and emotional numbing. Users frequently report feeling more emotionally present and stable after quitting.
          </Typography>
        </Container>

        {/* FAQ */}
        <Container maxWidth="md" style={{marginBottom: '64px', textAlign: 'left'}}>
          <Typography variant="h4" gutterBottom>Frequently Asked Questions</Typography>

          <Typography variant="h6" gutterBottom style={{marginTop: '24px'}}>Is The Warrior Tribe free to use?</Typography>
          <Typography variant="body1" paragraph>
            The Warrior Tribe offers a 14-day free trial when you install the extension. After the trial, a subscription plan is required to continue using the blocking and XP features. Plans are available on a monthly, half-year, or annual basis.
          </Typography>

          <Typography variant="h6" gutterBottom style={{marginTop: '16px'}}>How does the site blocking work?</Typography>
          <Typography variant="body1" paragraph>
            The Chrome extension intercepts browser navigation in real time. It checks every URL you visit against a comprehensive blocklist covering thousands of adult websites. If a match is found, you are immediately redirected before any content loads.
          </Typography>

          <Typography variant="h6" gutterBottom style={{marginTop: '16px'}}>What happens if I relapse?</Typography>
          <Typography variant="body1" paragraph>
            If you visit a blocked site, you will lose experience points and your streak will be affected. This is not meant to punish — it is designed to make consequences feel real and meaningful. Many users find this accountability mechanism more effective than willpower alone.
          </Typography>

          <Typography variant="h6" gutterBottom style={{marginTop: '16px'}}>What platforms are supported?</Typography>
          <Typography variant="body1" paragraph>
            The Warrior Tribe is currently available as a Google Chrome extension, compatible with any desktop or laptop running Chrome. Mobile blocking is not currently supported.
          </Typography>

          <Typography variant="h6" gutterBottom style={{marginTop: '16px'}}>Is my data private?</Typography>
          <Typography variant="body1" paragraph>
            We collect only the minimum data needed to operate the service — your Google account email address, your avatar name, and your XP and streak data. We do not sell your data to third parties. See our <Link color="primary" href="/privacy">Privacy Policy</Link> for full details.
          </Typography>

          <Typography variant="h6" gutterBottom style={{marginTop: '16px'}}>Can I see which sites are on the blocklist?</Typography>
          <Typography variant="body1" paragraph>
            The blocklist combines a curated static list with a dynamically updated list sourced from the StevenBlack hosts project — one of the most comprehensive open-source adult site blocklists available. It is refreshed automatically every 24 hours.
          </Typography>
        </Container>
    </div>
  );
}